export const HEX_COLOR_REGEX = /^#([0-9A-Fa-f]{3}){1,2}$/;
export const SLUG_REGEX = /^[a-z0-9-]+$/;

export const ACCEPTED_LOGO_TYPES = [
  "image/png",
  "image/jpeg",
  "image/jpg",
  "image/webp",
  "image/svg+xml",
];

export const MAX_LOGO_SIZE_BYTES = 2 * 1024 * 1024;

export function isValidHexColor(value) {
  return HEX_COLOR_REGEX.test(value ?? "");
}

export function isValidSlug(value) {
  return SLUG_REGEX.test(value ?? "");
}

export function validateLogoFile(file) {
  if (!file) {
    return null;
  }

  if (!ACCEPTED_LOGO_TYPES.includes(file.type)) {
    return "Logo must be a PNG, JPG, SVG, or WebP image.";
  }

  if (file.size > MAX_LOGO_SIZE_BYTES) {
    return "Logo must be 2MB or smaller.";
  }

  return null;
}
